<div class="lum-c-sku-stock-details-channel-orders">
  <div class="overflow-auto">
    <table class="lum-table lum-table--classic striped">
      <thead>
        <tr>
          <th>Order Date</th>
          <th>Order #</th>
          <th>Order Id</th>
          <th class="text-right">Ordered Qty</th>
          <th class="text-right">Base Qty</th>
          <th class="text-right">Unit Price</th>
          <th class="text-right">Line Total</th>
          <th>Channel</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="loading">
          <td colspan="8" class="text-center">
            <br />
            <h6 [translate]="'GENERAL.GETTING_RECORDS'">
              <i class="fas fa-spinner fa-spin"></i> Getting records...
            </h6>
            <br />
          </td>
        </tr>
        <ng-container *ngIf="!loading && records.data.length">
          <tr *ngFor="let r of records.data; let i = index">
            <td>{{ r.orderDate | date: 'mediumDate' }}</td>
            <td>
              <a
                class="lum-table lum-table--classic__row-link"
                title="View details"
                routerLink="/shipping/posted-orders"
                [queryParams]="{ orderNumber: r.orderNumber }"
                target="_blank"
                >{{ r.orderNumber }}</a
              >
            </td>
            <td>{{ r.orderId }}</td>
            <td class="text-right">
              {{ r.quantity | decimalPlaces }}
              <span *ngIf="r.ordered_uom">{{ r.ordered_uom?.name }} </span>
              <span class="text-info" *ngIf="r.kit">
                [ <b> {{ r.kit.sku }}</b
                >(KIT) ]
              </span>
            </td>
            <td class="text-right">
              <span class="text-success">
                {{ r.baseUomQty | decimalPlaces }}
              </span>
              <span *ngIf="r.base_uom">{{ r.base_uom?.name }} </span>
            </td>

            <td class="text-right">{{ r.unitPrice | currency: ' ' }}</td>
            <td class="text-right">{{ r.lineTotal | currency: ' ' }}</td>
            <td>
              <span *ngIf="r.order && r.order.channel_id > 0">
                {{ r.order && r.order.channel ? r.order.channel.label : '' }}
              </span>
              <span *ngIf="r.order && r.order.channel_id == 0">
                {{ luminousInvoicesChannelLabel }}
              </span>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>

  <mat-paginator
    *ngIf="records"
    class="lum-paging lum-paging--dodge-back-to-top lum-paging--sticky"
    [length]="records.total"
    [pageSize]="params.per_page"
    [pageIndex]="params.page - 1"
    [pageSizeOptions]="pageSizeOptions"
    (page)="getRecords($event)"
  ></mat-paginator>
</div>
